export default {
  'pages.userPaymentReview.title': 'مراجعة مدفوعات المستخدم (Migrated)',
  'pages.userPaymentReview.actions.search': 'بحث',
  'pages.userPaymentReview.actions.clear': 'مسح',
  'pages.userPaymentReview.actions.review': 'مراجعة الدفعة',
  'pages.userPaymentReview.filters.paymentDate': 'تاريخ الدفع',
  'pages.userPaymentReview.filters.reviewedDate': 'تاريخ المراجعة',
  'pages.userPaymentReview.filters.search': 'بحث',
  'pages.userPaymentReview.filters.searchPlaceholder':
    'رقم المستخدم أو الهاتف أو الاسم',
  'pages.userPaymentReview.filters.reviewedBy': 'تمت المراجعة بواسطة',
  'pages.userPaymentReview.filters.status': 'حالة المراجعة',
  'pages.userPaymentReview.filters.direction': 'الاتجاه',
  'pages.userPaymentReview.filters.type': 'نوع المعاملة',
  'pages.userPaymentReview.options.all': 'الكل',
  'pages.userPaymentReview.options.reviewed': 'تمت المراجعة',
  'pages.userPaymentReview.options.notReviewed': 'لم تتم المراجعة',
  'pages.userPaymentReview.options.payin': 'دفع',
  'pages.userPaymentReview.options.payout': 'صرف',
  'pages.userPaymentReview.options.installment': 'قسط',
  'pages.userPaymentReview.options.penalty': 'غرامة',
  'pages.userPaymentReview.columns.totalAmount': 'إجمالي المبلغ',
  'pages.userPaymentReview.columns.paidAmount': 'المبلغ المدفوع',
  'pages.userPaymentReview.columns.transactionFees': 'رسوم المعاملة',
  'pages.userPaymentReview.columns.settled': 'تمت التسوية',
  'pages.userPaymentReview.columns.dueDate': 'تاريخ الاستحقاق',
  'pages.userPaymentReview.columns.paidDate': 'تاريخ الدفع',
  'pages.userPaymentReview.columns.bundle': 'الحزمة',
  'pages.userPaymentReview.columns.transactionId': 'رقم المعاملة',
  'pages.userPaymentReview.columns.transactionSource': 'مصدر المعاملة',
  'pages.userPaymentReview.columns.transactionType': 'نوع المعاملة',
  'pages.userPaymentReview.columns.transactionDirection': 'اتجاه المعاملة',
  'pages.userPaymentReview.columns.notes': 'ملاحظات',
  'pages.userPaymentReview.columns.review': 'المراجعة',
  'pages.userPaymentReview.noFees': 'لا توجد رسوم',
  'pages.userPaymentReview.yes': 'نعم',
  'pages.userPaymentReview.no': 'لا',
  'pages.userPaymentReview.reviewedBy': 'تمت المراجعة بواسطة',
  'pages.userPaymentReview.at': 'في',
  'pages.userPaymentReview.modal.title': 'مراجعة الدفعة',
  'pages.userPaymentReview.modal.submit': 'مراجعة',
  'pages.userPaymentReview.modal.cancel': 'إلغاء',
  'pages.userPaymentReview.modal.reason': 'سبب المراجعة',
  'pages.userPaymentReview.modal.notes': 'ملاحظات المراجعة',
  'pages.userPaymentReview.modal.other': 'أخرى',
  'pages.userPaymentReview.messages.lookupsFailed':
    'تعذر تحميل بيانات المراجعة',
  'pages.userPaymentReview.messages.listFailed': 'تعذر تحميل مراجعات المدفوعات',
  'pages.userPaymentReview.messages.reviewAdded':
    'تمت إضافة مراجعة الدفعة بنجاح',
  'pages.userPaymentReview.messages.reviewFailed': 'فشلت مراجعة الدفعة',
  'pages.layouts.userLayout.title':
    'واجهة إدارة حديثة مبنية على Ant Design Pro',
  'pages.login.success': 'تم تسجيل الدخول بنجاح!',
  'pages.login.or': 'أو',
  'pages.login.keycloak': 'تسجيل الدخول عبر Keycloak',
  'pages.login.keycloak.description': 'تسجيل دخول آمن عبر مزود الهوية المؤسسي',
  'pages.login.keycloak.mock': 'تسجيل الدخول عبر Mock Keycloak',
  'pages.login.keycloak.mock.description':
    'استخدام مزود هوية وهمي للاختبار والتطوير',
  'pages.payout.title': 'إدارة المدفوعات الصادرة',
  'pages.payout.subtitle': 'إدارة مدفوعات المستخدمين والدفعات وعمليات التجميد',
  'pages.payout.search.placeholder': 'أدخل مصطلح البحث',
  'pages.payout.search.types.uuid': 'معرف فريد',
  'pages.payout.search.types.nationalId': 'الرقم القومي',
  'pages.payout.search.types.phoneNumber': 'رقم الهاتف',
  'pages.payout.filters.title': 'مرشحات متقدمة',
  'pages.payout.filters.payoutMonth': 'شهر الدفع',
  'pages.payout.filters.userTypes': 'نوع المستخدم',
  'pages.payout.filters.payoutAmount': 'مبلغ الدفع',
  'pages.payout.filters.payoutType': 'نوع الدفع',
  'pages.payout.filters.urgentCases': 'الحالات العاجلة',
  'pages.payout.filters.userTypes.individual': 'فردي',
  'pages.payout.filters.userTypes.selfPay': 'دفع ذاتي',
  'pages.payout.filters.userTypes.salaryDeduction': 'خصم من الراتب',
  'pages.payout.filters.payoutAmount.lessThan500': '≤ 500 جنيه',
  'pages.payout.filters.payoutAmount.moreThan500': '> 500 جنيه',
  'pages.payout.filters.payoutType.normal': 'دفع عادي',
  'pages.payout.filters.payoutType.early': 'دفع مبكر',
  'pages.payout.filters.urgentCases.yes': 'نعم',
  'pages.payout.filters.urgentCases.no': 'لا',
  'pages.payout.actions.bulkAddToBatch': 'إضافة جماعية للدفعة',
  'pages.payout.actions.bulkFreeze': 'تجميد جماعي للمستخدمين',
  'pages.payout.actions.export': 'تصدير البيانات',
  'pages.payout.table.uuid': 'معرف فريد',
  'pages.payout.table.fullName': 'الاسم الكامل',
  'pages.payout.table.nationalId': 'الرقم القومي',
  'pages.payout.table.phoneNumber': 'رقم الهاتف',
  'pages.payout.table.paymentMethod': 'طريقة الدفع',
  'pages.payout.table.paymentData': 'بيانات الدفع',
  'pages.payout.table.payoutAmount': 'مبلغ الدفع',
  'pages.payout.table.dueDate': 'تاريخ الاستحقاق',
  'pages.payout.table.cashoutDueDate': 'تاريخ استحقاق السحب',
  'pages.payout.table.status': 'الحالة',
  'pages.payout.table.newUser': 'مستخدم جديد',
  'pages.payout.table.updatedAt': 'تم التحديث في',
  'pages.payout.table.actions': 'الإجراءات',
  'pages.payout.table.actions.addToBatch': 'إضافة للدفعة',
  'pages.payout.table.actions.freeze': 'تجميد',
  'pages.payout.modals.addToBatch.title': 'إضافة مستخدم للدفعة',
  'pages.payout.modals.addToBatch.user': 'المستخدم',
  'pages.payout.modals.addToBatch.nationalId': 'الرقم القومي',
  'pages.payout.modals.addToBatch.amount': 'المبلغ',
  'pages.payout.modals.addToBatch.selectBatch': 'اختر الدفعة',
  'pages.payout.modals.freezeUser.title': 'تجميد دفع المستخدم',
  'pages.payout.modals.freezeUser.freezeReason': 'سبب التجميد',
  'pages.payout.modals.freezeUser.notes': 'ملاحظات إضافية (اختياري)',
  'pages.payout.modals.bulkAddToBatch.title': 'إضافة جماعية للدفعة',
  'pages.payout.modals.bulkAddToBatch.nationalIds':
    'الأرقام القومية (واحد في كل سطر)',
  'pages.payout.modals.bulkFreeze.title': 'تجميد جماعي للمستخدمين',
  'pages.payout.modals.validation.valid': 'صحيح',
  'pages.payout.modals.validation.invalid': 'غير صحيح',
  'pages.payout.modals.validation.duplicates': 'مكرر',
  'pages.payout.modals.results.success': 'تمت الإضافة بنجاح',
  'pages.payout.modals.results.failed': 'فشل في الإضافة',
  'pages.payout.modals.results.duplicates': 'تم تخطي المكررات',
  'pages.payout.modals.results.frozen': 'تم التجميد بنجاح',
  'pages.payout.modals.results.freezeFailed': 'فشل في التجميد',
  'pages.payout.messages.uuidCopied': 'تم نسخ المعرف الفريد إلى الحافظة',
  'pages.payout.messages.uuidCopyFailed': 'فشل في نسخ المعرف الفريد',
  'pages.payout.messages.searchFailed': 'فشل في البحث',
  'pages.payout.messages.fetchFailed': 'فشل في جلب بيانات الدفع',
  'pages.payout.messages.batchAdded': 'تم إضافة المستخدم للدفعة بنجاح',
  'pages.payout.messages.batchAddFailed': 'فشل في إضافة المستخدم للدفعة',
  'pages.payout.messages.userFrozen': 'تم تجميد المستخدم بنجاح',
  'pages.payout.messages.userFreezeFailed': 'فشل في تجميد المستخدم',
  'pages.payout.messages.bulkBatchAdded': 'تم إضافة المستخدمين للدفعة بنجاح',
  'pages.payout.messages.bulkBatchAddFailed': 'فشل في إضافة المستخدمين للدفعة',
  'pages.payout.messages.bulkUserFrozen': 'تم تجميد المستخدمين بنجاح',
  'pages.payout.messages.bulkUserFreezeFailed': 'فشل في تجميد المستخدمين',
  'pages.payout.messages.duplicatesSkipped': 'تم تخطي المستخدمين المكررين',
  'pages.payout.messages.exportInfo': 'سيتم تنفيذ وظيفة التصدير قريباً',
  'pages.leaveBundleRequests.title': 'طلبات مغادرة الحزمة (مهاجرة)',
  'pages.leaveBundleRequests.common.yes': 'نعم',
  'pages.leaveBundleRequests.common.no': 'لا',
  'pages.leaveBundleRequests.common.close': 'إغلاق',
  'pages.leaveBundleRequests.columns.actions': 'الإجراءات',
  'pages.leaveBundleRequests.actions.approve': 'موافقة',
  'pages.leaveBundleRequests.actions.cancel': 'إلغاء',
  'pages.leaveBundleRequests.filters.smartSaving': 'ادخار ذكي',
  'pages.leaveBundleRequests.filters.hasNotPayin': 'بدون استلام',
  'pages.leaveBundleRequests.filters.hasNotPayout': 'بدون دفع',
  'pages.leaveBundleRequests.filters.payoutMethods': 'طرق الدفع',
  'pages.leaveBundleRequests.disapprove.title': 'إلغاء طلب المغادرة',
  'pages.leaveBundleRequests.disapprove.note': 'ملاحظة',
  'pages.leaveBundleRequests.disapprove.confirm': 'إلغاء الطلب',
  'pages.leaveBundleRequests.remove.title': 'الموافقة على طلب المغادرة',
  'pages.leaveBundleRequests.remove.reason': 'سبب المغادرة',
  'pages.leaveBundleRequests.remove.note': 'ملاحظة',
  'pages.leaveBundleRequests.remove.confirm': 'موافقة',
  'pages.leaveBundleRequests.remove.inProgressConfirm':
    'العقد قيد التنفيذ. هل تريد المتابعة؟',
  'pages.leaveBundleRequests.remove.signedConfirm':
    'العقد موقع. هل تريد المتابعة؟',
  'pages.leaveBundleRequests.bulkApprove.toolbar': 'موافقة جماعية',
  'pages.leaveBundleRequests.bulkApprove.title':
    'موافقة جماعية على طلبات المغادرة',
  'pages.leaveBundleRequests.bulkApprove.requestIds': 'معرفات الطلبات',
  'pages.leaveBundleRequests.bulkApprove.requestIdsPlaceholder':
    'أدخل معرف طلب واحد في كل سطر',
  'pages.leaveBundleRequests.bulkApprove.category': 'الفئة',
  'pages.leaveBundleRequests.bulkApprove.reason': 'سبب المغادرة',
  'pages.leaveBundleRequests.bulkApprove.confirm': 'موافقة',
  'pages.leaveBundleRequests.messages.loadFailed':
    'فشل في جلب طلبات مغادرة الحزمة',
  'pages.leaveBundleRequests.messages.loadReasonsFailed':
    'تعذر تحميل أسباب المغادرة',
  'pages.leaveBundleRequests.messages.cancelSuccess': 'تم إلغاء الطلب',
  'pages.leaveBundleRequests.messages.cancelFailed': 'فشل في إلغاء الطلب',
  'pages.leaveBundleRequests.messages.removeSuccess':
    'تمت إزالة المستخدم من الحزمة',
  'pages.leaveBundleRequests.messages.removeFailed':
    'فشل في إزالة المستخدم من الحزمة',
  'pages.leaveBundleRequests.messages.bulkApproveSuccess':
    'اكتملت الموافقة الجماعية',
  'pages.leaveBundleRequests.messages.bulkApproveFailed':
    'فشلت الموافقة الجماعية',
  'pages.deadLetterMessages.title': 'الرسائل الميتة',
  'pages.deadLetterMessages.detailsTitle': 'تفاصيل الرسالة الميتة',
  'pages.deadLetterMessages.filters.broker': 'الوسيط',
  'pages.deadLetterMessages.filters.mainQueue': 'الطابور الرئيسي',
  'pages.deadLetterMessages.filters.status': 'الحالة',
  'pages.deadLetterMessages.filters.date': 'التاريخ',
  'pages.deadLetterMessages.stats.byStatus': 'الرسائل حسب الحالة',
  'pages.deadLetterMessages.stats.pendingByBroker': 'المعلقة حسب الوسيط',
  'pages.deadLetterMessages.stats.topQueues': 'أكثر الطوابير',
  'pages.deadLetterMessages.table.id': 'المعرف',
  'pages.deadLetterMessages.table.messageId': 'معرف الرسالة',
  'pages.deadLetterMessages.table.deadLetterQueue': 'طابور الرسائل الميتة',
  'pages.deadLetterMessages.table.receiveCount': 'عدد الاستلام',
  'pages.deadLetterMessages.table.errorReason': 'سبب الخطأ',
  'pages.deadLetterMessages.table.enqueuedAt': 'وقت الإدراج',
  'pages.deadLetterMessages.table.actions': 'الإجراءات',
  'pages.deadLetterMessages.actions.view': 'عرض',
  'pages.deadLetterMessages.actions.editPayload': 'تعديل المحتوى',
  'pages.deadLetterMessages.actions.redrive': 'إعادة الإرسال',
  'pages.deadLetterMessages.actions.bulkRedrive': 'إعادة إرسال جماعية',
  'pages.deadLetterMessages.actions.discard': 'تجاهل',
  'pages.deadLetterMessages.actions.refresh': 'تحديث',
  'pages.deadLetterMessages.modals.editPayload.title': 'تعديل محتوى الرسالة',
  'pages.deadLetterMessages.modals.bulkRedrive.title':
    'إعادة إرسال جماعية للرسائل الميتة',
  'pages.deadLetterMessages.modals.discard.title': 'تجاهل الرسالة',
  'pages.deadLetterMessages.modals.jobProgress.title':
    'تقدم مهمة إعادة الإرسال',
  'pages.deadLetterMessages.messages.fetchFailed': 'فشل في جلب الرسائل الميتة',
  'pages.deadLetterMessages.messages.redriveStarted':
    'تم بدء مهمة إعادة الإرسال',
  'pages.deadLetterMessages.messages.payloadUpdated': 'تم تحديث المحتوى بنجاح',
  'pages.deadLetterMessages.messages.discarded': 'تم تجاهل الرسالة بنجاح',
  'pages.quotaManagement.dashboard.title': 'لوحة التحكم',
  'pages.quotaManagement.dashboard.slotBadge':
    'خانة واحدة = باقة واحدة = {amount} جنيه',
  'pages.quotaManagement.dashboard.empty':
    'لا توجد بيانات لوحة التحكم للعرض حالياً',
  'pages.quotaManagement.dashboard.loadError':
    'فشل في تحميل بيانات لوحة التحكم.',
  'pages.quotaManagement.dashboard.kpi.total': 'إجمالي الخانات',
  'pages.quotaManagement.dashboard.kpi.assigned': 'المعيّن للأقسام',
  'pages.quotaManagement.dashboard.kpi.unassigned': 'غير معيّن',
  'pages.quotaManagement.dashboard.kpi.filled': 'الممتلئ',
  'pages.quotaManagement.dashboard.kpi.slots': 'خانات',
  'pages.quotaManagement.dashboard.kpi.percentOfTotal':
    '{percent}% من الإجمالي',
  'pages.quotaManagement.dashboard.kpi.unassignedHint':
    'غير معيّن للمرحلة التالية',
  'pages.quotaManagement.dashboard.kpi.payoutValue': 'قيمة الصرف {value}',
  'pages.quotaManagement.dashboard.kpi.filledSubtext':
    '{percent}% من الإجمالي · {value}',
  'pages.quotaManagement.dashboard.chart.title':
    'المستهدف مقابل الممتلئ حسب الخانة',
  'pages.quotaManagement.dashboard.chart.subtitle': '{name} · {duration} شهر',
  'pages.quotaManagement.dashboard.chart.durationLabel': 'المدة',
  'pages.quotaManagement.dashboard.chart.durationOption': '{duration} شهر',
  'pages.quotaManagement.dashboard.chart.empty':
    'لا توجد بيانات للمستهدف مقابل الممتلئ للعرض.',
  'pages.quotaManagement.dashboard.chart.legendTarget': 'المستهدف',
  'pages.quotaManagement.dashboard.chart.legendFilled': 'ممتلئ',
  'pages.quotaManagement.dashboard.chart.legendOpen': 'مفتوح',
  'pages.quotaManagement.dashboard.chart.note':
    'ارتفاع العمود = المستهدف · تأتي أهداف الخانات من توقعات العرض والطلب',
  'pages.quotaManagement.dashboard.chart.tooltip':
    'الخانة {slot}: {filled} ممتلئ · {open} مفتوح · {target} مستهدف ({percent}%)',
  'pages.quotaManagement.dashboard.table.title': 'الحصة حسب {type}',
  'pages.quotaManagement.dashboard.table.allocate': 'تخصيص ونقل',
  'pages.quotaManagement.dashboard.table.totalSlots': 'إجمالي الخانات',
  'pages.quotaManagement.dashboard.table.filled': 'الممتلئ',
  'pages.quotaManagement.dashboard.table.open': 'مفتوح',
  'pages.quotaManagement.dashboard.table.fillRate': 'نسبة الامتلاء',
  'pages.quotaManagement.dashboard.table.empty': 'لا توجد حصص للعرض.',
  'pages.quotaManagement.myQuota.title': 'لوحة التحكم',
  'pages.quotaManagement.myQuota.infoTag':
    'خانة واحدة = باقة واحدة = {amount} جنيه',
  'pages.quotaManagement.myQuota.filter.month': 'الشهر',
  'pages.quotaManagement.myQuota.summary.totalSlots': 'إجمالي الخانات',
  'pages.quotaManagement.myQuota.summary.slotsValue': '{count} خانات',
  'pages.quotaManagement.myQuota.summary.payoutCapacity':
    '{amount} القدرة على الصرف',
  'pages.quotaManagement.myQuota.summary.filled': 'المشغولة',
  'pages.quotaManagement.myQuota.summary.open': 'المتاحة',
  'pages.quotaManagement.myQuota.summary.acrossPositions':
    'عبر {count} موقع خانة',
  'pages.quotaManagement.myQuota.summary.fillRate': 'معدل الإشغال',
  'pages.quotaManagement.myQuota.summary.fillRateHint': 'من الخانات المخصصة لي',
  'pages.quotaManagement.myQuota.table.title': 'حصتي حسب المدة والخانة',
  'pages.quotaManagement.myQuota.table.readOnly': 'للعرض فقط',
  'pages.quotaManagement.myQuota.table.duration': 'المدة',
  'pages.quotaManagement.myQuota.table.slot': 'الخانة',
  'pages.quotaManagement.myQuota.table.totalSlots': 'إجمالي الخانات',
  'pages.quotaManagement.myQuota.table.filled': 'المشغولة',
  'pages.quotaManagement.myQuota.table.open': 'المتاحة',
  'pages.quotaManagement.myQuota.table.fill': 'الإشغال',
  'pages.quotaManagement.myQuota.table.fillRate': 'معدل الإشغال',
  'pages.quotaManagement.myQuota.table.payoutCapacityLeft':
    'القدرة المتبقية على الصرف',
  'pages.quotaManagement.myQuota.duration.months': '{count} أشهر',
  'pages.quotaManagement.myQuota.empty': 'لا توجد بيانات حصة للعرض حالياً',
  'pages.quotaManagement.myQuota.fetchFailed': 'فشل في تحميل بيانات الحصة.',
  'pages.quotaManagement.hierarchy.title': 'التسلسل الهرمي',
  'pages.quotaManagement.hierarchy.description': 'كل ما هو تحت {organization}',
  'pages.quotaManagement.hierarchy.empty':
    'لا توجد بيانات تسلسل هرمي للعرض حالياً',
  'pages.quotaManagement.hierarchy.loadError':
    'فشل في تحميل بيانات التسلسل الهرمي.',
  'pages.quotaManagement.hierarchy.noQuota': 'لا توجد حصة',
  'pages.quotaManagement.hierarchy.nodeMeta': '{type} · {owner}',
  'pages.quotaManagement.hierarchy.columns.node': 'العقدة',
  'pages.quotaManagement.hierarchy.columns.totalSlots': 'إجمالي الخانات',
  'pages.quotaManagement.hierarchy.columns.filled': 'المملوء',
  'pages.quotaManagement.hierarchy.columns.opened': 'المفتوح',
  'pages.quotaManagement.hierarchy.columns.fillRate': 'معدل الامتلاء',
  'pages.quotaManagement.hierarchy.columns.actions': 'الإجراءات',
  'pages.quotaManagement.hierarchy.actions.add': 'إضافة',
  'pages.quotaManagement.hierarchy.actions.edit': 'تعديل',
  'pages.quotaManagement.hierarchy.actions.delete': 'حذف',
  'pages.quotaManagement.hierarchy.addUnder': 'إضافة تحت {parent}',
  'pages.quotaManagement.hierarchy.addNode.title': 'إضافة تحت {parent}',
  'pages.quotaManagement.hierarchy.addNode.submit': 'إضافة عقدة',
  'pages.quotaManagement.hierarchy.addNode.cancel': 'إلغاء',
  'pages.quotaManagement.hierarchy.addNode.parent': 'الأصل',
  'pages.quotaManagement.hierarchy.addNode.type': 'النوع',
  'pages.quotaManagement.hierarchy.addNode.owner': 'المالك',
  'pages.quotaManagement.hierarchy.addNode.name': 'الاسم',
  'pages.quotaManagement.hierarchy.addNode.ownerPlaceholder':
    'لا يوجد مالك بعد.',
  'pages.quotaManagement.hierarchy.addNode.ownerHelp':
    'تعيين مالك هو ما يمنح ذلك الشخص صلاحية الوصول.',
  'pages.quotaManagement.hierarchy.addNode.namePlaceholder':
    'مثال: تجزئة الإسكندرية',
  'pages.quotaManagement.hierarchy.addNode.nameHelp':
    'تبدأ العقد الجديدة بدون حصة حتى يُعيِّن لها شخص أعلى حصة.',
  'pages.quotaManagement.hierarchy.addNode.typeRequired': 'يرجى اختيار النوع.',
  'pages.quotaManagement.hierarchy.addNode.nameRequired': 'يرجى إدخال الاسم.',
  'pages.quotaManagement.hierarchy.addNode.success': 'تمت إضافة العقدة بنجاح.',
  'pages.quotaManagement.hierarchy.addNode.error': 'فشل في إضافة العقدة.',
  'pages.quotaManagement.hierarchy.editNode.title': 'تعديل العقدة',
  'pages.quotaManagement.hierarchy.editNode.submit': 'حفظ',
  'pages.quotaManagement.hierarchy.editNode.success': 'تم تحديث العقدة بنجاح.',
  'pages.quotaManagement.hierarchy.editNode.error': 'فشل في تحديث العقدة.',
  'pages.quotaManagement.hierarchy.deleteNode.title': 'حذف العقدة',
  'pages.quotaManagement.hierarchy.deleteNode.confirm':
    'حذف {name}؟ لا يمكن التراجع عن هذا الإجراء.',
  'pages.quotaManagement.hierarchy.deleteNode.success': 'تم حذف العقدة بنجاح.',
  'pages.quotaManagement.hierarchy.deleteNode.error': 'فشل في حذف العقدة.',
  'pages.quotaManagement.hierarchy.types.organization': 'منظمة',
  'pages.quotaManagement.hierarchy.types.division': 'قناة',
  'pages.quotaManagement.hierarchy.types.channel': 'قناة فرعية',
  'pages.quotaManagement.hierarchy.types.team': 'قائد فريق',
  'pages.quotaManagement.hierarchy.types.agent': 'مندوب مبيعات',
  'pages.quotaManagement.slotAllocation.title': 'تخصيص ونقل الحصة',
  'pages.quotaManagement.slotAllocation.description':
    'تخصيص الحصة مستوى واحداً لأسفل ضمن نطاق التسلسل الهرمي المصرح به.',
  'pages.quotaManagement.slotAllocation.empty':
    'لا توجد بيانات تخصيص خانات للعرض حالياً',
  'pages.quotaManagement.slotAllocation.table.noChildren':
    'ليس لهذه العقدة أي أبناء — لا يوجد ما يمكن تخصيصه هنا.',
  'pages.quotaManagement.slotAllocation.table.notAllocatedYet':
    'لم يتم تخصيص أي شيء لهذه العقدة حتى الآن هذا الشهر، فلا يوجد جدول لتعديله.',
  'pages.quotaManagement.slotAllocation.loadError':
    'فشل في تحميل بيانات تخصيص الخانات.',
  'pages.quotaManagement.slotAllocation.slotBadge':
    'خانة واحدة = باقة واحدة = {amount} جنيه',
  'pages.quotaManagement.slotAllocation.duration.label': 'المدة',
  'pages.quotaManagement.slotAllocation.duration.option': '{duration} شهر',
  'pages.quotaManagement.slotAllocation.kpi.total': 'إجمالي الخانات',
  'pages.quotaManagement.slotAllocation.kpi.assigned': 'المعيّن',
  'pages.quotaManagement.slotAllocation.kpi.unassigned': 'غير معيّن',
  'pages.quotaManagement.slotAllocation.kpi.unassignedAll':
    'غير معيّن، كل المدد',
  'pages.quotaManagement.slotAllocation.kpi.slots': 'خانات',
  'pages.quotaManagement.slotAllocation.kpi.totalHint':
    '{duration} شهر · {amount}',
  'pages.quotaManagement.slotAllocation.kpi.assignedHint': 'عبر {count} أقسام',
  'pages.quotaManagement.slotAllocation.kpi.unassignedHint':
    'الإجمالي ناقص المعيّن',
  'pages.quotaManagement.slotAllocation.kpi.unassignedAllHint':
    '{percent}% من {total} خانة عبر كل المدد',
  'pages.quotaManagement.slotAllocation.table.title': 'تعيين حصة {name}',
  'pages.quotaManagement.slotAllocation.table.meta':
    '{count} أقسام · {duration} شهر · S{from}-S{to}',
  'pages.quotaManagement.slotAllocation.table.holder': 'الحامل',
  'pages.quotaManagement.slotAllocation.table.target': 'المستهدف',
  'pages.quotaManagement.slotAllocation.table.unassigned': 'غير معيّن',
  'pages.quotaManagement.slotAllocation.table.slot': 'S{slot}',
  'pages.quotaManagement.slotAllocation.table.holderMeta': '{type}',
  'pages.quotaManagement.slotAllocation.table.holderMetaWithChildren':
    '{type} · لديه أبناء',
  'pages.quotaManagement.slotAllocation.table.committed': '≥ {value}',
  'pages.quotaManagement.slotAllocation.table.legend':
    '≥ يحدد ما هو ملتزم به مسبقاً ولا يمكن نقله',
  'pages.quotaManagement.slotAllocation.table.splitting': 'تقسيم حصة {name}.',
  'pages.quotaManagement.slotAllocation.table.slotInput':
    '{holder} الخانة {slot}',
  'pages.quotaManagement.slotAllocation.filter.parent': 'العقدة الأصل',
  'pages.quotaManagement.slotAllocation.filter.holders':
    'تصفية الحاملين بالاسم',
  'pages.quotaManagement.slotAllocation.filter.holderCount': '{count} حاملون',
  'pages.quotaManagement.slotAllocation.actions.reset': 'إعادة تعيين',
  'pages.quotaManagement.slotAllocation.actions.confirm': 'تأكيد التغييرات',
  'pages.quotaManagement.slotAllocation.justification.title':
    'تأكيد التخصيص لهذه العقدة',
  'pages.quotaManagement.slotAllocation.justification.label': 'المبرر',
  'pages.quotaManagement.slotAllocation.justification.placeholder':
    'اشرح سبب تغيير تخصيص هذه العقدة',
  'pages.quotaManagement.slotAllocation.justification.required': 'المبرر مطلوب',
  'pages.quotaManagement.slotAllocation.justification.submit': 'تأكيد',
  'pages.quotaManagement.slotAllocation.justification.cancel': 'إلغاء',
  'pages.quotaManagement.slotAllocation.unsavedWarning':
    'أعد تعيين التغييرات غير المحفوظة أو أكّدها قبل تغيير المستوى أو المدة أو الشهر.',
  'pages.quotaManagement.slotAllocation.resetSuccess':
    'تم استعادة التغييرات غير المحفوظة.',
  'pages.quotaManagement.slotAllocation.confirmSuccess':
    'تم تأكيد تغييرات التخصيص.',
  'pages.quotaManagement.slotAllocation.confirmError':
    'فشل في تأكيد تغييرات التخصيص.',
  'pages.quotaManagement.slotAllocation.confirmValidation': '{errors}',
  'pages.quotaManagement.slotAllocation.validation.overAllocated':
    'لا يمكن أن تتجاوز تخصيصات الأبناء الخانات المتاحة للأصل.',
  'pages.quotaManagement.slotAllocation.validation.belowCommitted':
    'لا يمكن أن تقل الخانات المخصصة عن الكمية الملتزم بها.',
  'pages.quotaManagement.slotAllocation.forbidden.title': 'الوصول مرفوض',
  'pages.quotaManagement.slotAllocation.forbidden.description':
    'ليست لديك صلاحية عرض خطة التخصيص هذه.',
  'pages.pricingManagement.distribution.title': 'التوزيع',
  'pages.pricingManagement.distribution.description':
    'كيف يتم تحصيل الرسوم أو دفع الاسترداد النقدي',
  'pages.pricingManagement.distribution.empty':
    'لا توجد طرق توزيع للعرض حالياً.',
  'pages.pricingManagement.distribution.loadError': 'فشل في تحميل طرق التوزيع.',
  'pages.pricingManagement.distribution.table.title': 'طرق التوزيع',
  'pages.pricingManagement.distribution.table.count': '{count} طرق ({kind})',
  'pages.pricingManagement.distribution.tabs.fees': 'الرسوم',
  'pages.pricingManagement.distribution.tabs.cashback': 'الاسترداد النقدي',
  'pages.pricingManagement.distribution.kind.fees': 'الرسوم',
  'pages.pricingManagement.distribution.kind.cashback': 'الاسترداد النقدي',
  'pages.pricingManagement.distribution.summary.distributions': 'طرق التوزيع',
  'pages.pricingManagement.distribution.summary.distributionsHint':
    'قابلة لإعادة الاستخدام في كل قاعدة',
  'pages.pricingManagement.distribution.summary.inUse': 'قيد الاستخدام',
  'pages.pricingManagement.distribution.summary.inUseHint':
    'من {total} · مرتبطة بقاعدة واحدة على الأقل',
  'pages.pricingManagement.distribution.summary.feeMethods': 'طرق الرسوم',
  'pages.pricingManagement.distribution.summary.cashbackMethods':
    'طرق الاسترداد النقدي',
  'pages.pricingManagement.distribution.summary.baseHint': 'واحدة منها أساسية',
  'pages.pricingManagement.distribution.filters.name': 'الاسم',
  'pages.pricingManagement.distribution.filters.namePlaceholder':
    'ابحث في طرق التوزيع',
  'pages.pricingManagement.distribution.columns.distribution': 'طريقة التوزيع',
  'pages.pricingManagement.distribution.columns.type': 'النوع',
  'pages.pricingManagement.distribution.columns.whenToUse': 'متى تُستخدم',
  'pages.pricingManagement.distribution.columns.usedBy': 'مستخدمة بواسطة',
  'pages.pricingManagement.distribution.baseMethod': 'الطريقة الأساسية',
  'pages.pricingManagement.distribution.usage.unused': 'غير مستخدمة',
  'pages.pricingManagement.distribution.usage.rules': '{count} قواعد',
  'pages.pricingManagement.distribution.actions.new': 'إضافة طريقة توزيع',
  'pages.pricingManagement.distribution.actions.update': 'تحديث',
  'pages.pricingManagement.distribution.actions.view': 'عرض',
  'pages.pricingManagement.distribution.actions.delete': 'حذف',
  'pages.pricingManagement.distribution.actions.base': 'أساسية',
  'pages.pricingManagement.distribution.actions.soon':
    'هذا الإجراء سيكون متاحًا قريبًا.',
  'pages.pricingManagement.distribution.create.title': 'توزيع جديد',
  'pages.pricingManagement.distribution.create.crumb': 'التوزيع / جديد',
  'pages.pricingManagement.distribution.create.save': 'إضافة التوزيع',
  'pages.pricingManagement.distribution.create.saveSuccess':
    'تم إنشاء التوزيع.',
  'pages.pricingManagement.distribution.create.saveError':
    'فشل في إنشاء التوزيع.',
  'pages.pricingManagement.distribution.edit.title': 'تعديل التوزيع',
  'pages.pricingManagement.distribution.view.title': 'عرض التوزيع',
  'pages.pricingManagement.distribution.view.readOnly': 'للقراءة فقط',
  'pages.pricingManagement.distribution.view.liveRules':
    '{count, plural, one {قاعدة نشطة واحدة تستخدم هذا التوزيع} two {قاعدتان نشطتان تستخدمان هذا التوزيع} few {# قواعد نشطة تستخدم هذا التوزيع} other {# قاعدة نشطة تستخدم هذا التوزيع}}',
  'pages.pricingManagement.distribution.view.liveRulesDetail':
    'حفظ التغييرات يغيّر كيف تنقل الأموال من الطلب التالي.',
  'pages.pricingManagement.distribution.edit.crumb': 'التوزيع / {name}',
  'pages.pricingManagement.distribution.edit.save': 'حفظ التغييرات',
  'pages.pricingManagement.distribution.edit.saveSuccess': 'تم تحديث التوزيع.',
  'pages.pricingManagement.distribution.edit.saveError':
    'فشل في تحديث التوزيع.',
  'pages.pricingManagement.distribution.edit.loadError':
    'فشل في تحميل التوزيع.',
  'pages.pricingManagement.distribution.delete.title': 'حذف هذا التوزيع؟',
  'pages.pricingManagement.distribution.delete.body':
    'لا توجد قاعدة تستخدم "{name}"، لذا لا يتغير شيء يجري تسعيره اليوم.',
  'pages.pricingManagement.distribution.delete.confirm': 'حذف التوزيع',
  'pages.pricingManagement.distribution.delete.success': 'تم حذف التوزيع.',
  'pages.pricingManagement.distribution.delete.error': 'فشل في حذف التوزيع.',
  'pages.pricingManagement.distribution.form.name': 'الاسم',
  'pages.pricingManagement.distribution.form.namePlaceholder':
    'مثال: نصف المبلغ مقدمًا والباقي شهريًا',
  'pages.pricingManagement.distribution.form.nameHint':
    'ترتبط القواعد بطريقة التوزيع هذه بالاسم.',
  'pages.pricingManagement.distribution.form.nameRequired': 'الاسم مطلوب.',
  'pages.pricingManagement.distribution.form.type': 'النوع',
  'pages.pricingManagement.distribution.form.feesHint': 'تُحصَّل من العضو',
  'pages.pricingManagement.distribution.form.cashbackHint': 'تُعاد إلى العضو',
  'pages.pricingManagement.distribution.form.typeHint':
    'تحدد متى تُحصَّل الرسوم. أي مبلغ في شهر الصرف يُخصم من الوعاء بدلًا من تحصيله كقسط.',
  'pages.pricingManagement.distribution.form.typeHintCashback':
    'تحدد متى يُمنح خصم الاسترداد. لا يمكن استخدام شهر الصرف — العضو يحصّل الوعاء في ذلك الشهر — لذا هذه الخلية ثابتة عند 0٪.',
  'pages.pricingManagement.distribution.form.whenToUse': 'متى تُستخدم',
  'pages.pricingManagement.distribution.form.optional': 'اختياري',
  'pages.pricingManagement.distribution.form.whenToUsePlaceholder':
    'مثال: استخدمها للأعضاء ذوي المخاطر العالية، حيث يهم التحصيل المبكر أكثر من التجربة',
  'pages.pricingManagement.distribution.form.whenToUseHint':
    'تظهر في القائمة وبجانب هذه الطريقة عند اختيارها في القاعدة.',
  'pages.pricingManagement.distribution.form.shape': 'الشكل',
  'pages.pricingManagement.distribution.form.shapeProgress':
    'لكل خانة · {filled} من {total} مدد مكتملة',
  'pages.pricingManagement.distribution.form.durations': 'المدد',
  'pages.pricingManagement.distribution.form.durationsHint':
    'الثلاث مطلوبة · مجموع كل عمود خانة 100%',
  'pages.pricingManagement.distribution.form.months': '{count} أشهر',
  'pages.pricingManagement.distribution.form.instalment': 'القسط',
  'pages.pricingManagement.distribution.form.slot': 'الخانة {slot}',
  'pages.pricingManagement.distribution.form.month': 'الشهر {month}',
  'pages.pricingManagement.distribution.form.cancel': 'إلغاء',
  'pages.pricingManagement.rules.title': 'قواعد التسعير',
  'pages.pricingManagement.rules.description':
    'قاعدة واحدة لكل شريحة · تنتهي بتاريخ أو بحد للمستخدمين',
  'pages.pricingManagement.rules.empty': 'لا توجد قواعد تسعير للعرض حالياً.',
  'pages.pricingManagement.rules.loadError': 'فشل في تحميل قواعد التسعير.',
  'pages.pricingManagement.rules.table.title': 'القواعد',
  'pages.pricingManagement.rules.table.count': '{count} قواعد',
  'pages.pricingManagement.rules.summary.rules': 'القواعد',
  'pages.pricingManagement.rules.summary.segments': 'الشرائح المغطاة',
  'pages.pricingManagement.rules.summary.segmentsHint':
    'الباقي يُسعَّر حسب القاعدة الأساسية',
  'pages.pricingManagement.rules.summary.endingSoon': 'تنتهي خلال 14 يومًا',
  'pages.pricingManagement.rules.summary.endingSoonNone':
    'لا يوجد ما ينتهي قريبًا',
  'pages.pricingManagement.rules.summary.endingSoonHint': 'تنتهي قريبًا',
  'pages.pricingManagement.rules.filters.name': 'الاسم',
  'pages.pricingManagement.rules.filters.namePlaceholder': 'ابحث في القواعد',
  'pages.pricingManagement.rules.filters.status': 'الحالة',
  'pages.pricingManagement.rules.filters.statusAll': 'الكل',
  'pages.pricingManagement.rules.columns.rule': 'القاعدة',
  'pages.pricingManagement.rules.columns.reason': 'السبب',
  'pages.pricingManagement.rules.columns.covers': 'التغطية',
  'pages.pricingManagement.rules.columns.share': 'الحصة',
  'pages.pricingManagement.rules.columns.runsUntil': 'تسري حتى',
  'pages.pricingManagement.rules.columns.users': 'المستخدمون',
  'pages.pricingManagement.rules.columns.status': 'الحالة',
  'pages.pricingManagement.rules.columns.actions': 'الإجراءات',
  'pages.pricingManagement.rules.covers.everyRequest': 'كل الطلبات',
  'pages.pricingManagement.rules.share.withOne': 'مع قاعدة أخرى',
  'pages.pricingManagement.rules.share.withMany': 'مع {count} قواعد أخرى',
  'pages.pricingManagement.rules.share.theRest': 'الباقي',
  'pages.pricingManagement.rules.runsUntil.always': 'دائمًا',
  'pages.pricingManagement.rules.runsUntil.daysLeft': 'متبقٍ {days} يومًا',
  'pages.pricingManagement.rules.baseLayer': 'القاعدة الأساسية',
  'pages.pricingManagement.rules.actions.new': 'قاعدة جديدة',
  'pages.pricingManagement.rules.actions.update': 'تحديث',
  'pages.pricingManagement.rules.actions.removeUsers': 'إزالة المستخدمين',
  'pages.pricingManagement.rules.status.ACTIVE': 'نشط',
  'pages.pricingManagement.rules.status.INACTIVE': 'غير نشط',
  'pages.pricingManagement.rules.status.DEACTIVATED': 'متوقف',
  'pages.pricingManagement.rules.status.EXPIRED': 'منتهٍ',
  'pages.pricingManagement.rules.status.alwaysOn': 'دائمًا',
  'pages.pricingManagement.rules.status.deactivateTitle': 'إيقاف هذه القاعدة؟',
  'pages.pricingManagement.rules.status.deactivateBody':
    'هل تريد إيقاف "{name}"؟ سيُسعَّر مستخدمو {covers} وفق الطبقة الأساسية من طلبهم التالي.',
  'pages.pricingManagement.rules.status.deactivateOk': 'إيقاف',
  'pages.pricingManagement.rules.status.deactivateHint':
    'يمكنك إعادة تشغيلها ما دامت الشريحة متاحة.',
  'pages.pricingManagement.rules.status.activateTitle': 'تفعيل هذه القاعدة؟',
  'pages.pricingManagement.rules.status.activateBody':
    'هل تريد تفعيل "{name}"؟ سيُسعَّر مستخدمو {covers} وفق هذه القاعدة من طلبهم التالي.',
  'pages.pricingManagement.rules.status.activateOk': 'تفعيل',
  'pages.pricingManagement.rules.status.activateHint':
    'يفشل التفعيل إذا كانت حصة القاعدة أكبر من المتاح في الشريحة، أو إذا انتهت القاعدة.',
  'pages.pricingManagement.rules.status.usersSoFar': 'المستخدمون حتى الآن',
  'pages.pricingManagement.rules.status.wasRunningUntil': 'كانت تسري حتى',
  'pages.pricingManagement.rules.status.activateSuccess': 'تم تفعيل القاعدة.',
  'pages.pricingManagement.rules.status.deactivateSuccess': 'تم إيقاف القاعدة.',
  'pages.pricingManagement.rules.status.activateError': 'فشل تفعيل القاعدة.',
  'pages.pricingManagement.rules.status.deactivateError': 'فشل إيقاف القاعدة.',
  'pages.pricingManagement.rules.actions.newSoon':
    'إنشاء قاعدة سيكون متاحًا قريبًا.',
  'pages.pricingManagement.rules.actions.removeUsersSoon':
    'إزالة المستخدمين ستكون متاحة قريبًا.',
  'pages.pricingManagement.rules.removeUsers.title':
    'إزالة مستخدمين من هذه القاعدة',
  'pages.pricingManagement.rules.removeUsers.description':
    'المستخدم المُزال يُسعَّر وفق الطبقة الأساسية بدل هذه القاعدة. لا يمكن إضافة مستخدم إلى قاعدة — الشرائح تحدد من تغطيه.',
  'pages.pricingManagement.rules.removeUsers.uuidsLabel':
    'معرفات المستخدمين (UUID)، مفصولة بفواصل',
  'pages.pricingManagement.rules.removeUsers.uuidsPlaceholder':
    '3f2b1a10-1111-2222-3333-444444444444, 9e7c4d21-5555-6666-7777-888888888888',
  'pages.pricingManagement.rules.removeUsers.submit': 'إزالة من هذه القاعدة',
  'pages.pricingManagement.rules.removeUsers.removed':
    'تمت إزالة {count} · يُسعَّرون بالطبقة الأساسية',
  'pages.pricingManagement.rules.removeUsers.removedEmpty': 'لم يُزل أحد.',
  'pages.pricingManagement.rules.removeUsers.done': 'تم',
  'pages.pricingManagement.rules.removeUsers.required':
    'أدخل معرف مستخدم واحدًا على الأقل.',
  'pages.pricingManagement.rules.removeUsers.invalid':
    'هذه القيم ليست معرفات UUID صالحة: {uuids}',
  'pages.pricingManagement.rules.removeUsers.alreadyExcluded':
    'هؤلاء المستخدمون مُزالون بالفعل من هذه القاعدة.',
  'pages.pricingManagement.rules.removeUsers.loadError':
    'فشل في تحميل المستخدمين المُزالين.',
  'pages.pricingManagement.rules.removeUsers.submitSuccess':
    'تمت إزالة المستخدمين من هذه القاعدة.',
  'pages.pricingManagement.rules.removeUsers.submitError':
    'فشل في إزالة المستخدمين من هذه القاعدة.',
  'pages.pricingManagement.rules.removeUsers.undoError':
    'فشل في إعادة هذا المستخدم إلى القاعدة.',
  'pages.pricingManagement.rules.create.title': 'قاعدة جديدة',
  'pages.pricingManagement.rules.create.crumb': 'القواعد / قاعدة جديدة',
  'pages.pricingManagement.rules.create.save': 'إضافة قاعدة',
  'pages.pricingManagement.rules.create.saveSuccess': 'تم إنشاء القاعدة بنجاح.',
  'pages.pricingManagement.rules.create.saveError': 'فشل في إنشاء القاعدة.',
  'pages.pricingManagement.rules.create.loadError':
    'فشل في تحميل بيانات القاعدة الجديدة.',
  'pages.pricingManagement.rules.create.pricingExtra':
    'تبدأ من التسعير الأساسي · عدّل أي خلية',
  'pages.pricingManagement.rules.create.slotsHintExtra':
    'تبدأ هذه القاعدة من تعريفات الطبقة الأساسية ويمكن تغيير أي منها.',
  'pages.pricingManagement.rules.form.coversTitle': 'من تغطيهم',
  'pages.pricingManagement.rules.form.coversExtra': 'شريحة واحدة فقط',
  'pages.pricingManagement.rules.form.segment': 'الشريحة',
  'pages.pricingManagement.rules.form.segmentPlaceholder': 'اختر شريحة',
  'pages.pricingManagement.rules.form.segmentRequired': 'اختر شريحة.',
  'pages.pricingManagement.rules.form.taken': '{percent}% مستخدمة',
  'pages.pricingManagement.rules.form.segmentsPageHint':
    'يتم إنشاء الشرائح من صفحة الشرائح',
  'pages.pricingManagement.rules.form.scheduleTitle': 'مدة السريان',
  'pages.pricingManagement.rules.form.scheduleExtra':
    'اختياري — تسري حتى يتم إيقافها',
  'pages.pricingManagement.rules.form.startsAt': 'تاريخ البدء',
  'pages.pricingManagement.rules.form.endsAt': 'تاريخ الانتهاء',
  'pages.pricingManagement.rules.form.startsAtRequired': 'اختر تاريخ البدء.',
  'pages.pricingManagement.rules.form.endsAtPlaceholder': 'يوم/شهر/سنة',
  'pages.pricingManagement.rules.form.noEndDateHint':
    'بدون تاريخ انتهاء: تسري القاعدة حتى يقوم أحد بإيقافها.',
  'pages.pricingManagement.rules.form.endAfterStart':
    'يجب أن يكون تاريخ الانتهاء في يوم البدء أو بعده.',
  'pages.pricingManagement.rules.distribution.title': 'التوزيع',
  'pages.pricingManagement.rules.distribution.extra': 'كيف تتحرك الأموال',
  'pages.pricingManagement.rules.distribution.fees': 'للرسوم',
  'pages.pricingManagement.rules.distribution.cashback': 'للاسترداد النقدي',
  'pages.pricingManagement.rules.distribution.placeholder': 'اختر توزيعًا',
  'pages.pricingManagement.rules.distribution.feesRequired':
    'اختر توزيع الرسوم.',
  'pages.pricingManagement.rules.distribution.cashbackRequired':
    'اختر توزيع الاسترداد النقدي.',
  'pages.pricingManagement.rules.distribution.base': 'أساسية',
  'pages.pricingManagement.rules.distribution.usingBase':
    'يتم استخدام الطريقة الأساسية، {name}.',
  'pages.pricingManagement.rules.distribution.using': 'يتم استخدام {name}.',
  'pages.pricingManagement.rules.distribution.slotHint':
    'يستخدم كل دور الطريقة التي تطابق نوعه: أدوار الرسوم تُحصَّل بالطريقة الأولى، وأدوار الاسترداد النقدي تُرد بالطريقة الثانية.',
  'pages.pricingManagement.rules.distribution.loadError':
    'تعذر تحميل التوزيعات.',
  'pages.pricingManagement.rules.edit.title': 'تعديل القاعدة',
  'pages.pricingManagement.rules.edit.crumb': 'القواعد / {name}',
  'pages.pricingManagement.rules.edit.name': 'الاسم',
  'pages.pricingManagement.rules.edit.namePlaceholder':
    'مثال: اكتساب المستخدمين الجدد',
  'pages.pricingManagement.rules.edit.nameHint': 'يظهر في جدول القواعد.',
  'pages.pricingManagement.rules.edit.reason': 'السبب',
  'pages.pricingManagement.rules.edit.reasonOptional': 'اختياري',
  'pages.pricingManagement.rules.edit.reasonPlaceholder':
    'سبب وجود هذه القاعدة — مثال: اختبار الاحتفاظ للشرائح عالية المخاطر',
  'pages.pricingManagement.rules.edit.reasonHint':
    'يظهر في جدول القواعد حتى يوضح مجموعة القواعد نفسها.',
  'pages.pricingManagement.rules.edit.baseBannerTitle':
    'هذه طبقة التسعير الأساسية',
  'pages.pricingManagement.rules.edit.baseBannerBody':
    'تُسعِّر كل طلب لا تغطيه أي قاعدة، لذلك لا تحتوي على شريحة ولا تاريخ انتهاء. جدولها هو ما تُملأ منه القواعد الجديدة مسبقًا.',
  'pages.pricingManagement.rules.edit.pricing': 'التسعير',
  'pages.pricingManagement.rules.edit.durations': 'المدد',
  'pages.pricingManagement.rules.edit.duration': '{months} أشهر',
  'pages.pricingManagement.rules.edit.durationCounts':
    '{fees} رسوم · {cashback} استرداد',
  'pages.pricingManagement.rules.edit.slotsHint':
    'الخانة إما أن تفرض رسومًا أو تدفع استردادًا، موزعة على الأقساط. تخطي التحقق من الحد يفتحها للمستخدمين بحد ائتماني صفري. الوديعة تتطلب 100 جنيه مقدمًا.',
  'pages.pricingManagement.rules.edit.fees': 'رسوم',
  'pages.pricingManagement.rules.edit.cashback': 'استرداد',
  'pages.pricingManagement.rules.edit.columns.slot': 'الخانة',
  'pages.pricingManagement.rules.edit.columns.type': 'النوع',
  'pages.pricingManagement.rules.edit.columns.rate': 'النسبة',
  'pages.pricingManagement.rules.edit.columns.saverSlot': 'تخطي التحقق من الحد',
  'pages.pricingManagement.rules.edit.columns.deposit': 'الوديعة',
  'pages.pricingManagement.rules.edit.slotName': 'خانة {position}',
  'pages.pricingManagement.rules.edit.rateFee': '% رسوم',
  'pages.pricingManagement.rules.edit.rateBack': '% من القسط',
  'pages.pricingManagement.rules.edit.save': 'حفظ التغييرات',
  'pages.pricingManagement.rules.edit.cancel': 'إلغاء',
  'pages.pricingManagement.rules.edit.delete': 'حذف',
  'pages.pricingManagement.rules.edit.deleteTitle': 'حذف هذه القاعدة؟',
  'pages.pricingManagement.rules.edit.deleteConfirm':
    '«{name}» تتوقف عن التسعير فورًا ويعود مستخدموها إلى الطبقة الأساسية. لا يمكن التراجع عن ذلك.',
  'pages.pricingManagement.rules.edit.deleteOk': 'حذف القاعدة',
  'pages.pricingManagement.rules.edit.deleteSuccess': 'تم حذف القاعدة بنجاح.',
  'pages.pricingManagement.rules.edit.deleteError': 'فشل في حذف القاعدة.',
  'pages.pricingManagement.rules.edit.saveSuccess': 'تم تحديث القاعدة بنجاح.',
  'pages.pricingManagement.rules.edit.saveError': 'فشل في حفظ القاعدة.',
  'pages.pricingManagement.rules.edit.loadError':
    'تعذر العثور على هذه القاعدة.',
  'pages.pricingManagement.rules.edit.nameRequired': 'أدخل اسمًا لهذه القاعدة.',
  'pages.pricingManagement.rules.rollout.experimentTitle': 'التجربة',
  'pages.pricingManagement.rules.rollout.title': 'التوزيع',
  'pages.pricingManagement.rules.rollout.label': 'التوزيع',
  'pages.pricingManagement.rules.rollout.required':
    'أدخل نسبة توزيع من 1 إلى 100.',
  'pages.pricingManagement.rules.rollout.shareOf': 'حصة {name}',
  'pages.pricingManagement.rules.rollout.onlyChange':
    'الشيء الوحيد الذي يمكن تغييره',
  'pages.pricingManagement.rules.rollout.liveTitle':
    'هذه القاعدة تعمل — يمكن تغيير حصة التوزيع فقط',
  'pages.pricingManagement.rules.rollout.liveBody':
    'لا يمكن تعديل قاعدة تعمل إلا برفع نسبة التوزيع. يمكن تغيير كل الحقول للقواعد غير النشطة والمتوقفة والمنتهية.',
  'pages.pricingManagement.rules.rollout.liveHint':
    'تعمل عند {share}%. يمكنك رفعها حتى {max}%؛ تخفيضها يعني إيقاف القاعدة وإعادة توزيعها من جديد.',
  'pages.pricingManagement.rules.rollout.createHint':
    'يُسعَّر كل من في الشريحة بهذه القاعدة.',
  'pages.pricingManagement.rules.rollout.editHint':
    'يُسعَّر كل من في {name} بهذه القاعدة.',
  'pages.pricingManagement.rules.rollout.cannotLower':
    'لا يمكن أن تقل نسبة التوزيع عن {share}% بينما هذه القاعدة تعمل.',
  'pages.pricingManagement.rules.rollout.save': 'حفظ التوزيع',
  'pages.pricingManagement.rules.running.title': 'ما هو قيد التشغيل',
  'pages.pricingManagement.rules.running.readOnly': 'للقراءة فقط',
  'pages.pricingManagement.rules.running.runs': 'تسري',
  'pages.pricingManagement.rules.running.users': 'المستخدمون حتى الآن',
  'pages.pricingManagement.rules.running.yes': 'نعم',
  'pages.pricingManagement.rules.running.feesDistribution': 'الرسوم: {name}',
  'pages.pricingManagement.rules.running.cashbackDistribution':
    'الاسترداد النقدي: {name}',
  'pages.accessManagement.addRole': 'إضافة دور',
  'pages.accessManagement.editRole': 'تعديل الدور',
  'pages.accessManagement.create': 'إنشاء',
  'pages.accessManagement.update': 'تحديث',
  'pages.accessManagement.createSuccess': 'تم إنشاء الدور بنجاح',
  'pages.accessManagement.createError': 'فشل إنشاء الدور',
  'pages.accessManagement.updateSuccess': 'تم تحديث الدور بنجاح',
  'pages.accessManagement.updateError': 'فشل تحديث الدور',
  'pages.accessManagement.noRoleSelected': 'لم يتم اختيار دور',
  'pages.accessManagement.name': 'الاسم',
  'pages.accessManagement.name.required': 'يرجى إدخال الاسم',
  'pages.accessManagement.name.placeholder': 'أدخل اسم الدور',
  'pages.accessManagement.description': 'الوصف',
  'pages.accessManagement.description.required': 'يرجى إدخال الوصف',
  'pages.accessManagement.description.placeholder': 'أدخل وصف الدور',
  'pages.accessManagement.group': 'المجموعة',
  'pages.accessManagement.group.required': 'يرجى اختيار مجموعة',
  'pages.accessManagement.group.placeholder': 'اختر مجموعة',
  'pages.accessManagement.levelCode': 'رمز المستوى',
  'pages.accessManagement.levelCode.required': 'يرجى إدخال رمز المستوى',
  'pages.accessManagement.levelCode.placeholder': 'أدخل رمز المستوى',
  'pages.cardCashbackOffers.title': 'كاش باك الكارت (تم النقل)',
  'pages.cardCashbackOffers.search': 'بحث',
  'pages.cardCashbackOffers.clear': 'مسح',
  'pages.cardCashbackOffers.filters.status': 'الحالة',
  'pages.cardCashbackOffers.filters.startDate': 'تاريخ البداية',
  'pages.cardCashbackOffers.filters.endDate': 'تاريخ النهاية',
  'pages.cardCashbackOffers.columns.guid': 'المعرف',
  'pages.cardCashbackOffers.columns.value': 'القيمة',
  'pages.cardCashbackOffers.columns.capping': 'الحد الأقصى',
  'pages.cardCashbackOffers.columns.minimumSpending': 'الحد الأدنى للإنفاق',
  'pages.cardCashbackOffers.columns.startDate': 'تاريخ البداية',
  'pages.cardCashbackOffers.columns.endDate': 'تاريخ النهاية',
  'pages.cardCashbackOffers.columns.maxTransactions': 'أقصى عدد معاملات',
  'pages.cardCashbackOffers.columns.status': 'الحالة',
  'pages.cardCashbackOffers.columns.actions': 'الإجراءات',
  'pages.cardCashbackOffers.status.inactive': 'غير نشط',
  'pages.cardCashbackOffers.status.all': 'الكل',
  'pages.cardCashbackOffers.status.active': 'نشط',
  'pages.cardCashbackOffers.status.expired': 'منتهي',
  'pages.cardCashbackOffers.status.canceled': 'ملغي',
  'pages.cardCashbackOffers.status.unknown': 'غير معروف',
  'pages.cardCashbackOffers.actions.add': 'إضافة عرض كاش باك',
  'pages.cardCashbackOffers.actions.more': 'المزيد من الإجراءات',
  'pages.cardCashbackOffers.actions.edit': 'تعديل',
  'pages.cardCashbackOffers.actions.cancel': 'إلغاء',
  'pages.cardCashbackOffers.actions.delete': 'حذف',
  'pages.cardCashbackOffers.actions.keep': 'احتفاظ',
  'pages.cardCashbackOffers.form.addTitle': 'إضافة عرض كاش باك',
  'pages.cardCashbackOffers.form.editTitle': 'تعديل عرض كاش باك',
  'pages.cardCashbackOffers.form.type': 'نوع الكاش باك',
  'pages.cardCashbackOffers.form.percentage': 'نسبة مئوية',
  'pages.cardCashbackOffers.form.amount': 'مبلغ ثابت',
  'pages.cardCashbackOffers.form.value': 'قيمة الكاش باك',
  'pages.cardCashbackOffers.form.valuePercentage': 'نسبة مئوية',
  'pages.cardCashbackOffers.form.valueAmount': 'مبلغ ثابت',
  'pages.cardCashbackOffers.form.capping': 'الحد الأقصى',
  'pages.cardCashbackOffers.form.minimumSpending': 'الحد الأدنى للإنفاق',
  'pages.cardCashbackOffers.form.startDate': 'تاريخ البداية',
  'pages.cardCashbackOffers.form.endDate': 'تاريخ النهاية',
  'pages.cardCashbackOffers.form.maxTransactions':
    'أقصى عدد معاملات لكل مستخدم',
  'pages.cardCashbackOffers.form.save': 'حفظ',
  'pages.cardCashbackOffers.form.saveOffer': 'حفظ العرض',
  'pages.cardCashbackOffers.form.cancel': 'إلغاء',
  'pages.cardCashbackOffers.confirm.cancelTitle': 'إلغاء عرض الكاش باك',
  'pages.cardCashbackOffers.confirm.cancel': 'هل أنت متأكد من إلغاء هذا العرض؟',
  'pages.cardCashbackOffers.confirm.deleteTitle': 'حذف عرض الكاش باك',
  'pages.cardCashbackOffers.confirm.delete': 'هل أنت متأكد من حذف هذا العرض؟',
  'pages.cardCashbackOffers.messages.loadFailed': 'تعذر تحميل عروض الكاش باك.',
  'pages.cardCashbackOffers.messages.created': 'تم إنشاء عرض الكاش باك بنجاح.',
  'pages.cardCashbackOffers.messages.updated': 'تم تحديث عرض الكاش باك بنجاح.',
  'pages.cardCashbackOffers.messages.canceled': 'تم إلغاء عرض الكاش باك بنجاح.',
  'pages.cardCashbackOffers.messages.deleted': 'تم حذف عرض الكاش باك بنجاح.',
  'pages.cardCashbackOffers.messages.saveFailed': 'تعذر حفظ عرض الكاش باك.',
  'pages.cardCashbackOffers.messages.openEditFromList':
    'افتح العرض من قائمة الكاش باك لتحميل بياناته.',
  'pages.cardCashbackOffers.messages.cancelFailed': 'تعذر إلغاء عرض الكاش باك.',
  'pages.cardCashbackOffers.messages.deleteFailed': 'تعذر حذف عرض الكاش باك.',
  'pages.cardCashbackOffers.permissions.viewDenied':
    'ليست لديك صلاحية عرض عروض كاش باك الكارت.',
  'pages.cardCashbackOffers.validation.positiveValue':
    'يجب أن تكون القيمة أكبر من صفر.',
  'pages.cardCashbackOffers.validation.endAfterStart':
    'يجب أن يكون تاريخ النهاية بعد تاريخ البداية.',
  'pages.cardCashbackOffers.validation.positiveTransactions':
    'يجب أن يكون أقصى عدد معاملات أكبر من صفر.',
  'pages.accessManagement.manageGroups': 'إدارة المجموعات',
  'pages.accessManagement.addGroup': 'إضافة مجموعة',
  'pages.accessManagement.editGroup': 'تعديل المجموعة',
  'pages.accessManagement.groupName.placeholder': 'أدخل اسم المجموعة',
  'pages.accessManagement.groupDescription.placeholder': 'أدخل وصف المجموعة',
  'pages.accessManagement.groupCreateSuccess': 'تم إنشاء مجموعة الأدوار',
  'pages.accessManagement.groupCreateError': 'فشل إنشاء مجموعة الأدوار',
  'pages.accessManagement.groupUpdateSuccess': 'تم تحديث مجموعة الأدوار',
  'pages.accessManagement.groupUpdateError': 'فشل تحديث مجموعة الأدوار',
  'pages.accessManagement.groupDelete': 'حذف',
  'pages.accessManagement.groupDeleteConfirm': 'حذف مجموعة الأدوار هذه؟',
  'pages.accessManagement.groupDeleteSuccess': 'تم حذف مجموعة الأدوار',
  'pages.accessManagement.groupDeleteError':
    'لا يمكن حذف المجموعة لوجود أدوار مرتبطة بها، أو فشل الحذف',
  'pages.accessManagement.groupsLoadError': 'فشل تحميل مجموعات الأدوار',
  'pages.accessManagement.noGroupSelected': 'لم يتم اختيار مجموعة',
  'pages.accessManagement.actions': 'الإجراءات',
  'pages.pricingManagement.segments.title': 'الشرائح',
  'pages.pricingManagement.segments.description':
    'من تنطبق عليه القاعدة · قاعدة واحدة لكل شريحة.',
  'pages.pricingManagement.segments.empty': 'لا توجد شرائح للعرض حالياً.',
  'pages.pricingManagement.segments.unnamed': 'شريحة بدون اسم',
  'pages.pricingManagement.segments.definedCount':
    '{count, plural, one {شريحة واحدة معرّفة} two {شريحتان معرّفتان} few {# شرائح معرّفة} other {# شريحة معرّفة}}',
  'pages.pricingManagement.segments.rankNote':
    'عند مطابقة المستخدم لأكثر من شريحة، الشريحة الأعلى ترتيباً هي التي تحدد القاعدة التي تسعّره. استخدم «تغيير الترتيب» لإعادة الترتيب.',
  'pages.pricingManagement.segments.ranking.hint':
    'اسحب الصفوف إلى الترتيب الذي تريده.',
  'pages.pricingManagement.segments.ranking.handle': 'اسحب لإعادة الترتيب',
  'pages.pricingManagement.segments.columns.rank': 'الترتيب',
  'pages.pricingManagement.segments.columns.name': 'الشريحة',
  'pages.pricingManagement.segments.columns.covers': 'يشمل',
  'pages.pricingManagement.segments.columns.liveRules': 'قواعد نشطة',
  'pages.pricingManagement.segments.columns.liveRulesCount':
    '{count, plural, one {قاعدة نشطة} two {قاعدتان نشطتان} few {# قواعد نشطة} other {# قاعدة نشطة}}',
  'pages.pricingManagement.segments.columns.noLiveRules': 'لا يوجد',
  'pages.pricingManagement.segments.actions.new': 'شريحة جديدة',
  'pages.pricingManagement.segments.actions.edit': 'تعديل',
  'pages.pricingManagement.segments.actions.delete': 'حذف',
  'pages.pricingManagement.segments.actions.add': 'إضافة الشريحة',
  'pages.pricingManagement.segments.actions.save': 'حفظ التغييرات',
  'pages.pricingManagement.segments.actions.cancel': 'إلغاء',
  'pages.pricingManagement.segments.actions.changeRanking': 'تغيير الترتيب',
  'pages.pricingManagement.segments.actions.saveRanking': 'حفظ الترتيب',
  'pages.pricingManagement.segments.form.addTitle': 'شريحة جديدة',
  'pages.pricingManagement.segments.form.editTitle': 'تعديل الشريحة',
  'pages.pricingManagement.segments.form.nameTitle': 'الاسم',
  'pages.pricingManagement.segments.form.namePlaceholder':
    'مثال: كبار العملاء · مخاطر منخفضة',
  'pages.pricingManagement.segments.form.nameExtra':
    'القواعد ترتبط بهذه الشريحة عن طريق الاسم.',
  'pages.pricingManagement.segments.form.audienceTitle': 'الجمهور',
  'pages.pricingManagement.segments.form.required': 'مطلوب',
  'pages.pricingManagement.segments.userType.label': 'نوع المستخدم',
  'pages.pricingManagement.segments.userType.new': 'جديد',
  'pages.pricingManagement.segments.userType.existing': 'حالي',
  'pages.pricingManagement.segments.userType.both':
    'المستخدمون الجدد والحاليون معاً.',
  'pages.pricingManagement.segments.userType.only':
    'المستخدمون من نوع {type} فقط.',
  'pages.pricingManagement.segments.accountType.label': 'نوع الحساب',
  'pages.pricingManagement.segments.accountType.everyone': 'الجميع',
  'pages.pricingManagement.segments.accountType.individualOnly': 'الأفراد فقط',
  'pages.pricingManagement.segments.accountType.corporateOnly': 'الشركات فقط',
  'pages.pricingManagement.segments.accountType.everyoneHelp':
    'حسابات الأفراد والشركات.',
  'pages.pricingManagement.segments.accountType.individualOnlyHelp':
    'حسابات الأفراد فقط.',
  'pages.pricingManagement.segments.accountType.whichAccounts': 'أي حسابات',
  'pages.pricingManagement.segments.accountType.whichAccountsHint':
    'فارغ = كل حسابات الشركات',
  'pages.pricingManagement.segments.accountType.anyCorporateAccount':
    'أي حساب شركة',
  'pages.pricingManagement.segments.accountType.leaveEmpty':
    'اتركه فارغاً ليشمل كل حسابات الشركات.',
  'pages.pricingManagement.segments.accountType.namedAccounts':
    '{count, plural, one {الحساب المحدد فقط.} two {الحسابان المحددان فقط.} other {الحسابات الـ # المحددة فقط.}}',
  'pages.pricingManagement.segments.select.selectAll': 'تحديد الكل · {details}',
  'pages.pricingManagement.segments.select.optionCount':
    '{count, plural, one {خيار واحد} two {خياران} few {# خيارات} other {# خياراً}}',
  'pages.pricingManagement.segments.select.matchCount':
    '{count, plural, one {نتيجة واحدة} two {نتيجتان} few {# نتائج} other {# نتيجة}}',
  'pages.pricingManagement.segments.select.selectedCount': 'تم تحديد {count}',
  'pages.pricingManagement.segments.select.ratio': '{count} من {total}',
  'pages.pricingManagement.segments.select.searchAccounts': 'البحث في الحسابات',
  'pages.pricingManagement.segments.select.clear': 'مسح',
  'pages.pricingManagement.segments.select.noMatch':
    'لا توجد نتائج مطابقة لـ “{query}”.',
  'pages.pricingManagement.segments.attributes.title': 'سمات المستخدم',
  'pages.pricingManagement.segments.attributes.optional': 'اختياري',
  'pages.pricingManagement.segments.attributes.count': '{count} محددة',
  'pages.pricingManagement.segments.attributes.add': 'إضافة سمة',
  'pages.pricingManagement.segments.attributes.added': 'مضافة',
  'pages.pricingManagement.segments.attributes.number': 'رقم',
  'pages.pricingManagement.segments.attributes.numberWithUnit': 'رقم · {unit}',
  'pages.pricingManagement.segments.attributes.operatorIs': 'يساوي',
  'pages.pricingManagement.segments.attributes.operatorIsOneOf': 'أحد القيم',
  'pages.pricingManagement.segments.attributes.operatorRange': 'نطاق',
  'pages.pricingManagement.segments.attributes.bounds': '{min} – {max}',
  'pages.pricingManagement.segments.attributes.unknown':
    'غير موجودة في دليل السمات — ستبقى كما هي حتى تحذفها.',
  'pages.pricingManagement.segments.attributes.anyValue': 'أي {label}',
  'pages.pricingManagement.segments.attributes.remove': 'إزالة',
  'pages.pricingManagement.segments.attributes.matchAll': 'مطابقة الكل',
  'pages.pricingManagement.segments.attributes.matchAny': 'مطابقة أي',
  'pages.pricingManagement.segments.attributes.and': 'و',
  'pages.pricingManagement.segments.attributes.or': 'أو',
  'pages.pricingManagement.segments.attributes.summaryAll':
    'يجب أن يستوفي المستخدم كل هذه الشروط: {list}.',
  'pages.pricingManagement.segments.attributes.summaryAny':
    'يجب أن يستوفي المستخدم أي شرط من هذه الشروط: {list}.',
  'pages.pricingManagement.segments.attributes.emptyHint':
    'العمر أو الموقع أو النوع أو فئة المخاطر أو التقييم الائتماني — بنطاقات أو قيم محددة.',
  'pages.pricingManagement.segments.summary.label': 'يشمل',
  'pages.pricingManagement.segments.summary.everyUser': 'كل المستخدمين',
  'pages.pricingManagement.segments.summary.userTypeOnly':
    'المستخدمون من نوع {type}',
  'pages.pricingManagement.segments.summary.individualOnly': 'الأفراد فقط',
  'pages.pricingManagement.segments.summary.corporateAny': 'الشركات فقط',
  'pages.pricingManagement.segments.summary.corporateNamed': 'شركات {names}',
  'pages.pricingManagement.segments.summary.corporateAll':
    'الشركات — كل الحسابات محددة',
  'pages.pricingManagement.segments.summary.corporateMore':
    'شركات {names} و{count, plural, one {حساب آخر} two {حسابان آخران} few {# حسابات أخرى} other {# حساباً آخر}} محددة',
  'pages.pricingManagement.segments.summary.and': '{first} و{second}',
  'pages.pricingManagement.segments.summary.or': '{first} أو {second}',
  'pages.pricingManagement.segments.summary.attrAny': '{label} أي قيمة',
  'pages.pricingManagement.segments.summary.attrIn': '{label} {values}',
  'pages.pricingManagement.segments.summary.attrGte': '{label} ≥ {value}',
  'pages.pricingManagement.segments.summary.attrGt': '{label} > {value}',
  'pages.pricingManagement.segments.summary.attrLte': '{label} ≤ {value}',
  'pages.pricingManagement.segments.summary.attrLt': '{label} < {value}',
  'pages.pricingManagement.segments.summary.attrBetween': '{label} {from}–{to}',
  'pages.pricingManagement.segments.summary.attrEq': '{label} = {value}',
  'pages.pricingManagement.segments.validation.nameRequired': 'مطلوب.',
  'pages.pricingManagement.segments.validation.nameMax':
    'يجب ألا يتجاوز الاسم {max} حرفاً.',
  'pages.pricingManagement.segments.validation.userTypeRequired':
    'اختر خياراً واحداً على الأقل.',
  'pages.pricingManagement.segments.validation.valuesRequired':
    'اختر قيمة واحدة على الأقل.',
  'pages.pricingManagement.segments.validation.valueRequired': 'أدخل قيمة.',
  'pages.pricingManagement.segments.validation.rangeTopRequired':
    'أدخل الحد الأعلى للنطاق.',
  'pages.pricingManagement.segments.validation.rangeInverted': 'النطاق معكوس.',
  'pages.pricingManagement.segments.banner.liveRules':
    '{count, plural, one {قاعدة نشطة واحدة تستخدم هذه الشريحة} two {قاعدتان نشطتان تستخدمان هذه الشريحة} few {# قواعد نشطة تستخدم هذه الشريحة} other {# قاعدة نشطة تستخدم هذه الشريحة}}',
  'pages.pricingManagement.segments.banner.liveRulesDetail':
    'حفظ أي تعديل يعيدها إلى الشؤون المالية وإدارة المخاطر.',
  'pages.pricingManagement.segments.confirm.liveTitle':
    'حفظ التغييرات على شريحة نشطة؟',
  'pages.pricingManagement.segments.confirm.liveBody':
    '{count, plural, one {قاعدة نشطة واحدة تستخدم} two {قاعدتان نشطتان تستخدمان} few {# قواعد نشطة تستخدم} other {# قاعدة نشطة تستخدم}} هذه الشريحة. حفظ التغييرات يغيّر من يتم تسعيره بدءاً من الطلب التالي.',
  'pages.pricingManagement.segments.confirm.liveOk': 'حفظ التغييرات',
  'pages.pricingManagement.segments.confirm.discardTitle': 'تجاهل التغييرات؟',
  'pages.pricingManagement.segments.confirm.discardBody':
    'ستفقد التعديلات التي أجريتها على هذه الشريحة.',
  'pages.pricingManagement.segments.confirm.discardOk': 'تجاهل',
  'pages.pricingManagement.segments.confirm.deleteTitle': 'حذف هذه الشريحة؟',
  'pages.pricingManagement.segments.confirm.deleteBody':
    'لا توجد قاعدة تستخدم «{name}»، لذلك لن يتغير أي تسعير قائم اليوم. الحذف نهائي.',
  'pages.pricingManagement.segments.confirm.deleteCovers': 'يشمل: {covers}',
  'pages.pricingManagement.segments.confirm.blockedTitle':
    'هذه الشريحة قيد الاستخدام',
  'pages.pricingManagement.segments.confirm.blockedBody':
    'لا يمكن حذف «{name}» بينما {count, plural, one {تستخدمها قاعدة نشطة واحدة} two {تستخدمها قاعدتان نشطتان} few {تستخدمها # قواعد نشطة} other {تستخدمها # قاعدة نشطة}}. افصلها عنها أولاً ثم احذفها.',
  'pages.pricingManagement.segments.confirm.blockedOk': 'إغلاق',
  'pages.pricingManagement.segments.confirm.rankingTitle':
    'تغيير ترتيب الشرائح؟',
  'pages.pricingManagement.segments.confirm.rankingBody':
    'هل أنت متأكد من تغيير الترتيب؟ يسري الترتيب الجديد على عملية التسعير التالية.',
  'pages.pricingManagement.segments.confirm.rankingOk': 'تأكيد',
  'pages.pricingManagement.segments.messages.created': 'تم إنشاء الشريحة بنجاح',
  'pages.pricingManagement.segments.messages.updated': 'تم تحديث الشريحة بنجاح',
  'pages.pricingManagement.segments.messages.createFailed':
    'تعذر إنشاء الشريحة.',
  'pages.pricingManagement.segments.messages.updateFailed':
    'تعذر تحديث الشريحة.',
  'pages.pricingManagement.segments.messages.loadFailed':
    'تعذر تحميل نموذج الشريحة.',
  'pages.pricingManagement.segments.messages.notFound': 'تعذر تحميل الشريحة.',
  'pages.pricingManagement.segments.messages.catalogueFailed':
    'تعذر تحميل دليل السمات.',
  'pages.pricingManagement.segments.messages.accountsFailed':
    'تعذر تحميل حسابات الشركات.',
  'pages.pricingManagement.segments.messages.deleted': 'تم حذف الشريحة.',
  'pages.pricingManagement.segments.messages.rankingSaved': 'تم حفظ الترتيب.',
  'pages.pricingManagement.segments.messages.rankingFailed':
    'تعذر حفظ الترتيب الجديد.',
  'pages.pricingManagement.segments.messages.deleteFailed': 'تعذر حذف الشريحة.',
  'pages.pricingManagement.segments.messages.unsupportedShape':
    'هذه الشريحة تجمع شروطها بطريقة لا يمكن تعديلها من البوابة حالياً.',
  'pages.pricingManagement.audit.title': 'سجل التغييرات',
  'pages.pricingManagement.audit.description':
    'كل تغيير على قواعد التسعير والشرائح والتسعير الأساسي، الأحدث أولاً. لا يمكن تعديل السجلات أو حذفها.',
  'pages.pricingManagement.audit.table.title': 'سجل التغييرات',
  'pages.pricingManagement.audit.table.count': '{count} سجل',
  'pages.pricingManagement.audit.loadError': 'تعذر تحميل سجل التغييرات.',
  'pages.pricingManagement.audit.empty': 'لم يتم تسجيل أي تغييرات بعد.',
  'pages.pricingManagement.audit.emptyFiltered.title':
    'لا توجد سجلات مطابقة لهذا الفلتر',
  'pages.pricingManagement.audit.emptyFiltered.description':
    'جميع التغييرات ما زالت مسجلة — امسح الفلتر لعرض السجل الكامل.',
  'pages.pricingManagement.audit.emptyFiltered.clear': 'مسح الفلتر',
  'pages.pricingManagement.audit.filters.action': 'الإجراء',
  'pages.pricingManagement.audit.filters.allActions': 'كل الإجراءات',
  'pages.pricingManagement.audit.filters.date': 'التاريخ',
  'pages.pricingManagement.audit.filters.reset': 'إعادة تعيين',
  'pages.pricingManagement.audit.columns.action': 'الإجراء',
  'pages.pricingManagement.audit.columns.whatHappened': 'ما الذي حدث',
  'pages.pricingManagement.audit.columns.appliedTo': 'مطبق على',
  'pages.pricingManagement.audit.columns.date': 'التاريخ',
  'pages.pricingManagement.audit.columns.admin': 'المسؤول',
  'pages.pricingManagement.audit.actions.created': 'إنشاء',
  'pages.pricingManagement.audit.actions.edited': 'تعديل',
  'pages.pricingManagement.audit.actions.deleted': 'حذف',
  'pages.pricingManagement.audit.actions.reordered': 'إعادة ترتيب',
  'pages.pricingManagement.audit.actions.activated': 'تفعيل',
  'pages.pricingManagement.audit.actions.deactivated': 'إيقاف',
  'pages.pricingManagement.audit.actions.usersExcluded': 'استبعاد مستخدمين',
  'pages.pricingManagement.audit.actions.userExclusionsRemoved':
    'إلغاء الاستبعاد',
  'pages.pricingManagement.audit.targetTypes.pricingRule': 'قاعدة',
  'pages.pricingManagement.audit.targetTypes.segment': 'شريحة',
  'pages.pricingManagement.audit.targetTypes.basePricing': 'التسعير الأساسي',
  'pages.pricingManagement.audit.sentence.rule': 'القاعدة «{name}»',
  'pages.pricingManagement.audit.sentence.ruleUnnamed': 'قاعدة',
  'pages.pricingManagement.audit.sentence.segment': 'الشريحة «{name}»',
  'pages.pricingManagement.audit.sentence.segmentUnnamed': 'شريحة',
  'pages.pricingManagement.audit.sentence.basePricing': 'التسعير الأساسي',
  'pages.pricingManagement.audit.sentence.Created': 'تم إنشاء {target}',
  'pages.pricingManagement.audit.sentence.Edited': 'تم تعديل {target}',
  'pages.pricingManagement.audit.sentence.Deleted': 'تم حذف {target}',
  'pages.pricingManagement.audit.sentence.Reordered': 'تم تغيير ترتيب الشرائح',
  'pages.pricingManagement.audit.sentence.Activated': 'تم تفعيل {target}',
  'pages.pricingManagement.audit.sentence.Deactivated': 'تم إيقاف {target}',
  'pages.pricingManagement.audit.sentence.UsersExcluded':
    'تم استبعاد {count} مستخدم من {target}',
  'pages.pricingManagement.audit.sentence.UserExclusionsRemoved':
    'تمت إعادة {count} مستخدم إلى {target}',
  'pages.pricingManagement.audit.changes.field': 'الحقل',
  'pages.pricingManagement.audit.changes.before': 'قبل',
  'pages.pricingManagement.audit.changes.after': 'بعد',
  'pages.pricingManagement.audit.values.yes': 'نعم',
  'pages.pricingManagement.audit.values.no': 'لا',
  'pages.pricingManagement.audit.values.userType.new': 'جديد',
  'pages.pricingManagement.audit.values.userType.existing': 'حالي',
  'pages.pricingManagement.audit.values.userType.both': 'الكل',
  'pages.pricingManagement.audit.values.accountType.everyone': 'الجميع',
  'pages.pricingManagement.audit.values.accountType.individualOnly':
    'الأفراد فقط',
  'pages.pricingManagement.audit.values.accountType.corporateOnly':
    'الشركات فقط',
  'pages.pricingManagement.audit.fields.Name': 'الاسم',
  'pages.pricingManagement.audit.fields.Reason': 'السبب',
  'pages.pricingManagement.audit.fields.SegmentId': 'الشريحة',
  'pages.pricingManagement.audit.fields.IsActive': 'مفعلة',
  'pages.pricingManagement.audit.fields.ActivatedAt': 'تاريخ التفعيل',
  'pages.pricingManagement.audit.fields.DeactivatedAt': 'تاريخ الإيقاف',
  'pages.pricingManagement.audit.fields.StartsAt': 'تاريخ البدء',
  'pages.pricingManagement.audit.fields.EndsAt': 'تاريخ الانتهاء',
  'pages.pricingManagement.audit.fields.RolloutPercentage': 'نسبة الإطلاق',
  'pages.pricingManagement.audit.fields.Ranges': 'النطاقات',
  'pages.pricingManagement.audit.fields.Slots': 'الأدوار',
  'pages.pricingManagement.audit.fields.Priority': 'الأولوية',
  'pages.pricingManagement.audit.fields.UserType': 'نوع المستخدم',
  'pages.pricingManagement.audit.fields.AccountType': 'نوع الحساب',
  'pages.pricingManagement.audit.fields.CorporateAccountIds': 'حسابات الشركات',
  'pages.pricingManagement.audit.fields.Attributes': 'الخصائص',
  'pages.pricingManagement.audit.fields.SegmentIds': 'ترتيب الشرائح',
  'pages.pricingManagement.audit.fields.UserUuids': 'المستخدمون',
  'pages.cardPromoCodeCampaigns.title': 'حملات أكواد خصم البطاقة (تم النقل)',
  'pages.cardPromoCodeCampaigns.search': 'بحث',
  'pages.cardPromoCodeCampaigns.clear': 'مسح',
  'pages.cardPromoCodeCampaigns.status.active': 'نشطة',
  'pages.cardPromoCodeCampaigns.status.all': 'الكل',
  'pages.cardPromoCodeCampaigns.status.inactive': 'غير نشطة',
  'pages.cardPromoCodeCampaigns.status.expired': 'منتهية',
  'pages.cardPromoCodeCampaigns.status.deactivated': 'معطلة',
  'pages.cardPromoCodeCampaigns.compatibility.addOnTop': 'إضافة فوق الخصم',
  'pages.cardPromoCodeCampaigns.compatibility.notCompatible': 'غير متوافق',
  'pages.cardPromoCodeCampaigns.compatibility.override': 'استبدال الخصم',
  'pages.cardPromoCodeCampaigns.actions.create': 'إنشاء حملة',
  'pages.cardPromoCodeCampaigns.actions.activate': 'تفعيل',
  'pages.cardPromoCodeCampaigns.actions.deactivate': 'تعطيل',
  'pages.cardPromoCodeCampaigns.actions.confirm': 'تأكيد',
  'pages.cardPromoCodeCampaigns.actions.cancel': 'إلغاء',
  'pages.cardPromoCodeCampaigns.form.title': 'حملة كود خصم بطاقة جديدة',
  'pages.cardPromoCodeCampaigns.form.steps.benefits': 'المزايا',
  'pages.cardPromoCodeCampaigns.form.steps.configuration': 'إعداد الحملة',
  'pages.cardPromoCodeCampaigns.form.steps.eligibility': 'أهلية المستخدمين',
  'pages.cardPromoCodeCampaigns.form.discountType': 'الخصم',
  'pages.cardPromoCodeCampaigns.form.discountValue': 'قيمة الخصم',
  'pages.cardPromoCodeCampaigns.form.percentage': 'نسبة مئوية',
  'pages.cardPromoCodeCampaigns.form.amount': 'مبلغ ثابت',
  'pages.cardPromoCodeCampaigns.form.compatibility': 'توافق الخصم',
  'pages.cardPromoCodeCampaigns.form.campaignName': 'العنوان',
  'pages.cardPromoCodeCampaigns.form.description': 'الوصف',
  'pages.cardPromoCodeCampaigns.form.startDate': 'تاريخ ووقت البداية',
  'pages.cardPromoCodeCampaigns.form.endDate': 'تاريخ ووقت الانتهاء',
  'pages.cardPromoCodeCampaigns.form.maxRedemptions': 'الحد الأقصى للاستخدام',
  'pages.cardPromoCodeCampaigns.form.collectionWindow': 'نافذة التحصيل بالأيام',
  'pages.cardPromoCodeCampaigns.form.zeroUnlimited': 'استخدم 0 لعدد غير محدود.',
  'pages.cardPromoCodeCampaigns.form.promoCode': 'كود الخصم',
  'pages.cardPromoCodeCampaigns.form.promoCodeHint':
    'استخدم من 3 إلى 30 حرفًا إنجليزيًا أو رقمًا. لا تستخدم مسافات أو رموزًا. لا يوجد فرق بين الأحرف الكبيرة والصغيرة.',
  'pages.cardPromoCodeCampaigns.form.eligibility': 'المستخدمون المؤهلون',
  'pages.cardPromoCodeCampaigns.form.allUsers': 'كل المستخدمين',
  'pages.cardPromoCodeCampaigns.form.uploadUsers': 'رفع قائمة مستخدمين',
  'pages.cardPromoCodeCampaigns.form.excelRequirementsTitle':
    'كيفية تجهيز ملف Excel',
  'pages.cardPromoCodeCampaigns.form.excelFileTypes':
    'ارفع ملفًا بصيغة .xlsx أو .xls.',
  'pages.cardPromoCodeCampaigns.form.excelFirstWorksheet':
    'نقرأ ورقة العمل الأولى فقط.',
  'pages.cardPromoCodeCampaigns.form.excelColumnA':
    'ضع كل قيمة لمستخدم مؤهل في العمود A.',
  'pages.cardPromoCodeCampaigns.form.excelNoHeader':
    'لا تضف صف عناوين. سيتم استيراد كل خلية غير فارغة في العمود A.',
  'pages.cardPromoCodeCampaigns.form.uploadPrompt': 'اختر ملف Excel للأهلية',
  'pages.cardPromoCodeCampaigns.form.previous': 'السابق',
  'pages.cardPromoCodeCampaigns.form.next': 'التالي',
  'pages.cardPromoCodeCampaigns.form.create': 'إنشاء الحملة',
  'pages.cardPromoCodeCampaigns.form.cancel': 'إلغاء',
  'pages.cardPromoCodeCampaigns.validation.promoCodeRequired':
    'يرجى إدخال كود الخصم.',
  'pages.cardPromoCodeCampaigns.validation.promoCodeLength':
    'يجب أن يتراوح كود الخصم بين 3 و30 حرفًا أو رقمًا.',
  'pages.cardPromoCodeCampaigns.validation.promoCodeCharacters':
    'استخدم الأحرف الإنجليزية والأرقام فقط. لا يُسمح بالمسافات أو الرموز.',
  'pages.cardPromoCodeCampaigns.messages.created': 'تم إنشاء الحملة بنجاح.',
  'pages.cardPromoCodeCampaigns.messages.activated': 'تم تفعيل الحملة بنجاح.',
  'pages.cardPromoCodeCampaigns.messages.deactivated': 'تم تعطيل الحملة بنجاح.',
  'pages.circlesMigrated.title': 'الدوائر (مُرحّلة)',
  'pages.circlesMigrated.yes': 'نعم',
  'pages.circlesMigrated.no': 'لا',
  'pages.circlesMigrated.type.real': 'حقيقية',
  'pages.circlesMigrated.type.overbooking': 'حجز زائد',
  'pages.circlesMigrated.visibility.public': 'عامة',
  'pages.circlesMigrated.visibility.private': 'خاصة',
  'pages.circlesMigrated.column.id': 'المعرف',
  'pages.circlesMigrated.column.type': 'النوع',
  'pages.circlesMigrated.column.started': 'بدأت',
  'pages.circlesMigrated.column.startedOn': 'تاريخ البدء',
  'pages.circlesMigrated.column.ended': 'انتهت',
  'pages.circlesMigrated.column.payoutAmount': 'مبلغ الاستلام',
  'pages.circlesMigrated.column.installment': 'القسط',
  'pages.circlesMigrated.column.availableSlots': 'الأماكن المتاحة',
  'pages.circlesMigrated.column.circleType': 'نوع الدائرة',
  'pages.circlesMigrated.column.createdAt': 'تاريخ الإنشاء',
  'pages.circlesMigrated.filter.all': 'الكل',
  'pages.circlesMigrated.filter.startedFrom': 'تبدأ من',
  'pages.circlesMigrated.filter.startedTo': 'تبدأ حتى',
  'pages.circlesMigrated.filter.payoutFrom': 'مبلغ الاستلام من',
  'pages.circlesMigrated.filter.payoutTo': 'مبلغ الاستلام إلى',
  'pages.circlesMigrated.filter.status': 'الحالة',
  'pages.circlesMigrated.filter.status.notStarted': 'لم تبدأ',
  'pages.circlesMigrated.filter.status.started': 'بدأت',
  'pages.circlesMigrated.filter.status.ended': 'انتهت',
  'pages.circlesMigrated.filter.completeness': 'توفر الأماكن',
  'pages.circlesMigrated.filter.onlyIncomplete': 'غير المكتملة فقط',
  'pages.circlesMigrated.filter.onlyComplete': 'المكتملة فقط',
  'pages.circlesMigrated.filter.visibility': 'نوع الدائرة',
  'pages.circlesMigrated.filter.slots': 'المدة',
  'pages.circlesMigrated.filter.slots.months': '{count} أشهر',
  'pages.circlesMigrated.action.search': 'بحث',
  'pages.circlesMigrated.action.clear': 'مسح',
  'pages.circlesMigrated.action.createCircle': 'إنشاء دائرة جديدة',
  'pages.circlesMigrated.action.manageEdl': 'إدارة EDL',
  'pages.circlesMigrated.action.startAll': 'بدء جميع الدوائر',
  'pages.circlesMigrated.action.create': 'إنشاء',
  'pages.circlesMigrated.action.apply': 'تطبيق',
  'pages.circlesMigrated.action.confirm': 'تأكيد',
  'pages.circlesMigrated.action.cancel': 'إلغاء',
  'pages.circlesMigrated.confirm.startAll':
    'هل أنت متأكد من رغبتك في بدء جميع الدوائر؟',
  'pages.circlesMigrated.form.duration': 'عدد الأشهر',
  'pages.circlesMigrated.form.duration.required': 'يرجى اختيار عدد الأشهر',
  'pages.circlesMigrated.form.noOfCircles': 'عدد الدوائر',
  'pages.circlesMigrated.form.noOfCircles.required': 'يرجى إدخال عدد الدوائر',
  'pages.circlesMigrated.form.startDate': 'تاريخ البدء',
  'pages.circlesMigrated.form.startDate.required': 'يرجى اختيار تاريخ البدء',
  'pages.circlesMigrated.form.overbooking': 'دوائر الحجز الزائد',
  'pages.circlesMigrated.form.freeSlotsForPosition':
    'الأماكن المتاحة للترتيب ({position})',
  'pages.circlesMigrated.form.slotsForPosition': 'الأماكن للترتيب ({position})',
  'pages.circlesMigrated.form.unlockEdl': 'فتح EDL',
  'pages.circlesMigrated.form.blockEdl': 'حظر EDL',
  'pages.circlesMigrated.messages.fetchFailed': 'فشل في جلب الدوائر',
  'pages.circlesMigrated.messages.durationsFailed': 'فشل في تحميل مدد الدوائر',
  'pages.circlesMigrated.messages.createSuccess': 'تم إنشاء الدوائر بنجاح',
  'pages.circlesMigrated.messages.createFailed': 'فشل في إنشاء الدوائر',
  'pages.circlesMigrated.messages.manageEdlSuccess': 'تم تحديث EDL بنجاح',
  'pages.circlesMigrated.messages.manageEdlFailed': 'فشل في تحديث EDL',
  'pages.circlesMigrated.messages.startAllSuccess': 'تم بدء الدوائر بنجاح',
  'pages.circlesMigrated.messages.startAllFailed': 'فشل في بدء الدوائر',
  'pages.circlesMigrated.messages.noListPermission':
    'ليس لديك صلاحية لعرض قائمة الدوائر.',
};
